import(/* webpackMode: "eager" */ "/codebuild/output/src1690089694/src/apps/fanychance/src/app/error.tsx");
